
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {ClientReport} from './ClientReport';
import {FieldModelClientReport} from './ClientReport';

/**
 * ClientReportsInsertResponse struct
 */
class ClientReportsInsertResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} clientReports
   * @constructor
   */
  constructor (parent = new Response(), clientReports = []) {
    super()
    super.copy(parent)
    this.ClientReports = clientReports
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ClientReportsInsertResponse}
   * @param {!ClientReportsInsertResponse} other Other struct
   * @returns {!ClientReportsInsertResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ClientReports != null) {
      this.ClientReports = []
      for (let item of other.ClientReports) {
        if (item != null) {
          let tempItem
          tempItem = ClientReport.fromObject(item)
          this.ClientReports.push(tempItem)
        } else {
          this.ClientReports.push(null)
        }
      }
    } else {
      this.ClientReports = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ClientReportsInsertResponse}
   * @returns {!ClientReportsInsertResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ClientReportsInsertResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ClientReportsInsertResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ClientReportsInsertResponse}
   * @param {!ClientReportsInsertResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportsInsertResponse)) {
      throw new TypeError('Instance of ClientReportsInsertResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ClientReportsInsertResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ClientReports: ((this.ClientReports != null) ? Array.from(this.ClientReports, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ClientReportsInsertResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ClientReportsInsertResponse} other Object value
   * @returns {!ClientReportsInsertResponse} Created struct
   */
  static fromObject (other) {
    return new ClientReportsInsertResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ClientReportsInsertResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ClientReportsInsertResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ClientReportsInsertResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3033
  }
}

export { ClientReportsInsertResponse };

/**
 * Fast Binary Encoding ClientReportsInsertResponse field model
 */
class FieldModelClientReportsInsertResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.ClientReports = new fbe.FieldModelVector(new FieldModelClientReport(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ClientReports.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ClientReports.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelClientReportsInsertResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3033
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientReports.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientReports.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReports.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!ClientReportsInsertResponse} fbeValue Default value, defaults is new ClientReportsInsertResponse()
   * @returns {!ClientReportsInsertResponse} ClientReportsInsertResponse value
   */
  get (fbeValue = new ClientReportsInsertResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!ClientReportsInsertResponse} fbeValue ClientReportsInsertResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientReports.fbeSize) <= fbeStructSize) {
      this.ClientReports.get(fbeValue.ClientReports)
    } else {
      fbeValue.ClientReports.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReports.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelClientReportsInsertResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {!ClientReportsInsertResponse} fbeValue ClientReportsInsertResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelClientReportsInsertResponse}
   * @param {ClientReportsInsertResponse} fbeValue ClientReportsInsertResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ClientReports.set(fbeValue.ClientReports)
  }
}

export { FieldModelClientReportsInsertResponse };

/**
 * Fast Binary Encoding ClientReportsInsertResponse model
 */
class ClientReportsInsertResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelClientReportsInsertResponse(this.buffer, 4)
  }

  /**
   * Get the ClientReportsInsertResponse model
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!FieldModelClientReportsInsertResponse} model ClientReportsInsertResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ClientReportsInsertResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelClientReportsInsertResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ClientReportsInsertResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ClientReportsInsertResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ClientReportsInsertResponseModel}
   * @param {!ClientReportsInsertResponse} value ClientReportsInsertResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ClientReportsInsertResponseModel}
   * @param {!ClientReportsInsertResponse} value ClientReportsInsertResponse value, defaults is new ClientReportsInsertResponse()
   * @return {!object} Deserialized ClientReportsInsertResponse value and its size
   */
  deserialize (value = new ClientReportsInsertResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ClientReportsInsertResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ClientReportsInsertResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ClientReportsInsertResponseModel}
   * @param {!number} prev Previous ClientReportsInsertResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ClientReportsInsertResponseModel };
